import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLogOut, FiCalendar, FiUser, FiHome, FiFileText } from 'react-icons/fi';
import { PiDog } from "react-icons/pi";
import { AiOutlineTeam, AiOutlineCheck } from "react-icons/ai";
import { MdOutlineTask, MdSchool } from "react-icons/md";
import { BsClipboardCheck } from "react-icons/bs";
import { TrainerContext } from "../../context/TrainerContext";
import '../../styles/MobileSidebar.css';

const MobileTrainerSidebar = () => {
    const navigate = useNavigate();
    const { trainer } = useContext(TrainerContext);

    // Display trainer's name
    const displayName = trainer?.firstName && trainer?.lastName
        ? `${trainer.firstName} ${trainer.lastName}`
        : trainer?.username || 'Trainer';

    const handleLogout = () => {
        // Clean up authentication
        localStorage.removeItem('jwt');

        // Close the mobile sidebar and remove backdrop (same logic as navigateTo)
        const mobileSidebar = document.querySelector('.mobile-sidebar');
        const backdrop = document.querySelector('.sidebar-backdrop');

        if (mobileSidebar) {
            mobileSidebar.classList.remove('open');
        }

        if (backdrop) {
            backdrop.remove();
        }

        // Navigate to home page
        navigate('/');
    };

    const navigateTo = (path) => {
        navigate(path);
        // Find and close the sidebar
        const mobileSidebar = document.querySelector('.mobile-sidebar');
        const backdrop = document.querySelector('.sidebar-backdrop');

        if (mobileSidebar) {
            mobileSidebar.classList.remove('open');
        }

        if (backdrop) {
            backdrop.remove();
        }
    };

    return (
        <div className="mobile-sidebar">
            <div className="profile-section">
                <div className="profile-icon">
                    <span>{displayName.charAt(0)}</span>
                </div>
                <p>{displayName}</p>
            </div>

            <nav className="nav-section">
                <ul>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/dashboard')}>
                            <FiHome /> Dashboard
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/podopieczni')} data-onboarding="pets">
                            <PiDog /> Podopieczni
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/owners/all')} data-onboarding="owners">
                            <AiOutlineTeam /> Właściciele
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/exercises')} data-onboarding="exercises">
                            <MdOutlineTask /> Ćwiczenia
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/reports')} data-onboarding="reports">
                            <FiFileText /> Raporty
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo(`/survey/school/${trainer?.schoolId}/all`)} data-onboarding="surveys">
                            <BsClipboardCheck /> Ankiety
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/calendar')} data-onboarding="calendar">
                            <FiCalendar /> Kalendarz
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/trainings/confirmed')} data-onboarding="trainings">
                            <AiOutlineCheck /> Treningi
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/trainer/groups')} data-onboarding="groups">
                            <AiOutlineTeam /> Grupy
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/school/details')} data-onboarding="school">
                            <MdSchool /> Szkoła
                        </button>
                    </li>
                    <li>
                        <button className="nav-button" onClick={() => navigateTo('/trainer/account')} data-onboarding="my-account">
                            <FiUser /> Moje konto
                        </button>
                    </li>
                </ul>
            </nav>

            <button className="logout-button" onClick={handleLogout}>
                <FiLogOut className="logout-icon" /> Wyloguj się
            </button>
        </div>
    );
};

export default MobileTrainerSidebar;